module.exports = {
      id: "ic-scale-full-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "sprite-2c53a1.smartcharts.svg#ic-scale-full-usage",
      toString: function () {
        return this.url;
      }
    }